import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteVideoData, getVideoDatas,} from "../../../redux/modules/Video/action";

class Video extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getVideoDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.video.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const videoColumn = [
            {
                name: "Name",
                path: "name",
                show: true,
            },
            {
                name: "Video",
                path: "video",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Video Data"}
                        data={this.props.video.datas}
                        columns={videoColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteVideoData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    video: state.video,
});

const mapDispatchToProps = {
    getVideoDatas,
    deleteVideoData,
};

export default MainLayout(connect(mapStateToProps, mapDispatchToProps)(Video));
